<template>
	<div class="destaques max-w-6xl mx-auto py-6">
		<!-- Área de Arrastar e Soltar -->
		<draggable v-model="destaques" group="noticias" @end="salvarOrdenacao" item-key="id"
			class="destaques-image-grid border border-gray-300 border-dashed p-2 rounded-lg">
			<a v-for="(destaque, index) in destaques" :key="destaque.id" :class="index === 0 ? takeTwo : ''"
				class="relative block overflow-hidden cursor-grab border border-gray-400 border-dashed rounded-md transition duration-200 ease-in-out hover:border-gray-600">
				<!-- Imagem -->
				<img :src="formatImageUrl(destaque.capa)" alt="" class="w-full h-full object-cover" @error="handleImageError" />

				<!-- Numeração e título -->
				<span class="absolute top-2 left-2 bg-black text-white px-2 py-1 text-sm rounded-md">
					{{ index + 1 }}
				</span>
				<span class="textos absolute bottom-0 left-0 right-0 p-2 text-white text-center">
					<span class="title-wrapper">
						<p class="title">{{ destaque.title }}</p>
						<p class="text-xs mt-1">{{ formatDate(destaque.datanot) }} - {{ destaque.categoria_name }}</p>
					</span>
				</span>
			</a>
		</draggable>

		<!-- Paginação -->
		<div class="flex justify-center mt-4" v-if="pagination.last_page > 1">
			<button @click="loadPage(pagination.current_page - 1)" :disabled="!pagination.prev_page_url"
				class="px-4 py-2 mx-1 rounded border disabled:opacity-50">
				Anterior
			</button>

			<button v-for="page in visiblePages" :key="page" @click="loadPage(page)"
				:class="{ 'bg-blue-500 text-white': page === pagination.current_page }" class="px-4 py-2 mx-1 rounded border">
				{{ page }}
			</button>

			<button @click="loadPage(pagination.current_page + 1)" :disabled="!pagination.next_page_url"
				class="px-4 py-2 mx-1 rounded border disabled:opacity-50">
				Próxima
			</button>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable/src/vuedraggable'
import axios from 'axios'

export default {
	components: { draggable },
	data() {
		return {
			takeTwo: 'destaques-image-grid-col-2 destaques-image-grid-row-2',
			loading: false,
			destaques: [],
			pagination: {
				current_page: 1,
				last_page: 1,
				prev_page_url: null,
				next_page_url: null
			},
			placeholder: 'https://via.placeholder.com/300x200?text=Sem+Imagem',
		}
	},
	computed: {
		visiblePages() {
			const pages = []
			const current = this.pagination.current_page
			const last = this.pagination.last_page

			// Mostrar até 5 páginas na paginação
			let start = Math.max(1, current - 2)
			let end = Math.min(last, start + 4)

			// Ajustar se estiver no final
			if (end - start < 4) {
				start = Math.max(1, end - 4)
			}

			for (let i = start; i <= end; i++) {
				pages.push(i)
			}

			return pages
		}
	},
	methods: {
		async carregarDestaques(page = 1) {
			this.loading = true
			try {
				const response = await axios.get(`/noticias?destaque=5&page=${page}`)

				this.destaques = response.data.data.map(item => ({
					...item,
					capa: this.formatImageUrl(item.capa),
				}))

				this.pagination = {
					current_page: response.data.current_page,
					last_page: response.data.last_page,
					prev_page_url: response.data.prev_page_url,
					next_page_url: response.data.next_page_url
				}
				// eslint-disable-next-line no-console
				console.log('Destaques carregados:', this.destaques)
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error('Erro ao carregar destaques:', error)
			}
			this.loading = false
		},

		async salvarOrdenacao() {
			try {
				const ordenacao = this.destaques.map((item, index) => ({
					id: item.id,
					ordenar: index + 1,
				}))

				await axios.patch('/noticias/ordenar-destaques', { ordenacao })
				// eslint-disable-next-line no-console
				console.log('Ordenação salva com sucesso!')
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error('Erro ao salvar ordenação:', error)
			}
		},

		loadPage(page) {
			if (page >= 1 && page <= this.pagination.last_page) {
				this.carregarDestaques(page)
			}
		},

		formatImageUrl(url) {
			if (!url) return this.placeholder
			if (!url.startsWith('http')) {
				return `https://www.anastacio.ms.gov.br${url}`
			}
			return url
		},

		formatDate(dateString) {
			const options = { day: 'numeric', month: 'long', year: 'numeric' }
			return new Date(dateString).toLocaleDateString('pt-BR', options)
		},

		handleImageError(event) {
			event.target.src = this.placeholder
		},
	},
	mounted() {
		this.carregarDestaques()
	},
}
</script>

<style scoped>
.destaques {
	max-width: 1440px;
	margin: 2rem auto 0;
	display: grid;
	position: relative;
}

.destaques-image-grid {
	--gap: 1rem;
	--num-cols: 4;
	--row-height: 300px;
	box-sizing: border-box;
	padding: var(--gap) 0;
	display: grid;
	grid-template-columns: repeat(var(--num-cols), 1fr);
	grid-auto-rows: var(--row-height);
	gap: var(--gap);
}

.destaques-image-grid>a {
	position: relative;
}

.destaques-image-grid>a img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.destaques-image-grid>a .textos {
	position: absolute;
	bottom: 20px;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.destaques-image-grid>a .title {
	font-size: 16px;
	font-weight: bold;
	color: white;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
}

.destaques-image-grid>a .title-wrapper {
	background-color: rgba(0, 0, 0, 0.6);
	padding: 10px;
	width: 90%;
	border-radius: 4px;
}

.destaques-image-grid-col-2 {
	grid-column: span 2;
}

.destaques-image-grid-row-2 {
	grid-row: span 2;
}

/* Efeito de borda tracejada para indicar movimento */
.destaques-image-grid {
	border: 2px dashed #ccc;
	padding: 10px;
	border-radius: 8px;
	transition: border-color 0.3s ease;
}

.destaques-image-grid:hover {
	border-color: #888;
}

.destaques-image-grid>a {
	border: 2px dashed #aaa;
	border-radius: 8px;
	padding: 5px;
}

.destaques-image-grid>a:hover {
	border-color: #555;
}

@media screen and (max-width: 1024px) {
	.destaques-image-grid {
		--row-height: 200px;
	}
}

@media screen and (max-width: 768px) {
	.destaques-image-grid {
		--num-cols: 2;
		--row-height: 250px;
	}
}

@media screen and (max-width: 425px) {
	.destaques-image-grid {
		--num-cols: 1;
		--row-height: 300px;
	}

	.destaques-image-grid-col-2 {
		grid-column: span 1;
	}

	.destaques-image-grid-row-2 {
		grid-row: span 1;
	}
}
</style>